import model from '../models-v2/crm/agreement-file';

export default [
  {
    path: '/crm-agreement-files',
    name: 'crm-agreement-files',
    components: {
      default: () => import('../pages/data-grid.vue'),
      topRightSection: () => import('../components-v2/top-right-section.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'CRM', url: '/clients' },
        { title: 'Dokumenty', url: '/crm-agreement-files' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
      topRightSection: (props) => ({ ...props, actions: model.topRightActions }),
    },
  },
  {
    path: '/crm-agreement-files/add',
    name: 'crm-agreement-files-add',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'CRM', url: '/clients' },
        { title: 'Dokumenty', url: '/crm-agreement-files' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
  {
    path: '/crm-agreement-files/edit/:id',
    name: 'crm-agreement-files-edit',
    components: {
      default: () => import('../pages/model-form.vue'),
    },
    meta: {
      breadcrumb: [
        { title: 'CRM', url: '/clients' },
        { title: 'Dokumenty', url: '/crm-agreement-files' },
      ],
      rule: 'editor',
      search: false,
      module: 'CRM',
    },
    props: {
      default: (props) => ({ ...props, model }),
    },
  },
];
